<template>
  <div>
    <panel
      v-for="(entry, index) in data"
      :title="entry.label"
      :key="index"
      collapsable
    >
      <template v-slot:actions>
        <el-button
          icon="el-icon-printer"
          size="medium"
          class="print-dugme"
          circle
          @click="openPrintSchema(entry)"
        />
      </template>
      <div v-for="category in entry.items" :key="category.id">
        <div class="category-header">
          <label class="label">{{ category.name }}:</label>
          <el-button-group class="ml-10">
            <el-button
              icon="el-icon-printer"
              size="mini"
              type="primary"
              plain
              @click="openCategoryPrintSchema(category, entry, null)"
            >
              Sve
            </el-button>
            <el-button
              v-if="hasMaleDisciplines(category)"
              size="mini"
              type="primary"
              plain
              @click="openCategoryPrintSchema(category, entry, true)"
            >
              M
            </el-button>
            <el-button
              v-if="hasFemaleDisciplines(category)"
              size="mini"
              type="primary"
              plain
              @click="openCategoryPrintSchema(category, entry, false)"
            >
              Ž
            </el-button>
          </el-button-group>
        </div>
        <div
          v-for="discipline in category.items"
          :key="discipline.id"
          class="discipline"
        >
          <span>{{ discipline.name }} | </span>
          <el-button-group>
            <el-button
              v-if="showSex(discipline, true)"
              icon="el-icon-printer"
              size="mini"
              type="primary"
              plain
              @click="openPreview(category, discipline, entry.isTeam, true)"
            >
              M ({{
                preGetCompetitors(
                  category.id,
                  discipline.id,
                  entry.isTeam ? teams : competitors,
                  "M",
                  entry.isTeam
                )
              }})
            </el-button>
            <el-button
              v-if="showSex(discipline, false)"
              icon="el-icon-printer"
              size="mini"
              type="primary"
              plain
              @click="openPreview(category, discipline, entry.isTeam, false)"
            >
              Ž ({{
                preGetCompetitors(
                  category.id,
                  discipline.id,
                  entry.isTeam ? teams : competitors,
                  "F",
                  entry.isTeam
                )
              }})
            </el-button>
            <el-button
              v-if="entry.isTeam && !discipline.forSex"
              icon="el-icon-printer"
              size="mini"
              type="primary"
              plain
              @click="openPreview(category, discipline, entry.isTeam, null)"
            >
              M/Ž ({{
                preGetCompetitors(
                  category.id,
                  discipline.id,
                  teams,
                  null,
                  entry.isTeam
                )
              }})
            </el-button>
          </el-button-group>
        </div>
      </div>
    </panel>

    <el-dialog
      :title="
        category && discipline ? category.name + ' - ' + discipline.name + ' [' + getSexString(isMale) + ']' : ''
      "
      :visible="!!modalData"
      width="90%"
      :key="isTeam"
      @close="closePreview()"
    >
      <el-table :data="modalData" style="width: 100%">
        <el-table-column :label="$tc('general.n0')" width="50px">
          <template slot-scope="scope"> {{ scope.$index + 1 }}. </template>
        </el-table-column>

        <el-table-column
          v-if="!isTeam"
          :label="$tc('form.image')"
          width="100px"
        >
          <template slot-scope="scope">
            <main-image
              :src="$file('avatars', scope.row.competitor.avatar)"
              style="width: 75px; height: 75px"
            />
          </template>
        </el-table-column>

        <el-table-column :label="$tc('form.name')">
          <template slot-scope="scope">
            {{ getCompetitorNames(scope.row, scope.row.assignedNumber) }}
          </template>
        </el-table-column>

        <el-table-column v-if="!isTeam" :label="$tc('form.belt')" width="120px">
          <template slot-scope="scope">
            {{ scope.row.competitor.belt | belt }}
          </template>
        </el-table-column>

        <el-table-column
          v-if="!isTeam"
          :label="$tc('form.date_of_birth')"
          width="150px"
        >
          <template slot-scope="scope">
            {{ scope.row.competitor.born | date }}
          </template>
        </el-table-column>

        <el-table-column
          v-if="isTeam"
          :label="$tc('general.type')"
          width="150px"
        >
          <template slot-scope="scope">
            {{ scope.row.type | teamType }}
          </template>
        </el-table-column>

        <el-table-column :label="$tc('club.short_name')">
          <template slot-scope="scope">
            <span v-if="scope.row.club && scope.row.club.logo" style="display: inline-block; vertical-align: middle; margin-right: 8px;">
              <img
                :src="$file('avatars', scope.row.club.logo)"
                style="width: 32px; height: 32px; object-fit: contain; vertical-align: middle;"
                alt=""
              />
            </span>
            {{ scope.row.club.shortName }}, {{ scope.row.club.city }}
          </template>
        </el-table-column>

        <el-table-column :label="$tc('general.placement')" width="100px" align="center">
          <template>
            <span style="display: inline-block; width: 28px; height: 28px; border: 1px solid #333; background: #fff;"></span>
          </template>
        </el-table-column>
      </el-table>

      <template v-slot:footer>
        <el-button @click="closePreview()">{{
          $tc("general.close")
        }}</el-button>
        <el-button
          type="primary"
          @click="
            openPrint(
              tournament.name,
              $refs.printTable ? $refs.printTable.$el : null
            )
          "
          >{{ $tc("general.print") }}</el-button
        >
      </template>
    </el-dialog>

    <print-table-disciplines
      v-if="schemaData"
      v-show="false"
      ref="printSchema"
      :data="schemaData"
      :teams="teams"
      :competitors="competitors"
    />

    <tournament-print-modal
      v-if="modalData"
      v-show="false"
      ref="printTable"
      :isTeam="isTeam"
      :isMale="isMale"
      :category="category"
      :discipline="discipline"
      :competitors="isTeam ? teams : competitors"
    />

    <el-dialog
      v-if="categoryPrintData"
      :title="categoryPrintData ? categoryPrintData.category.name : ''"
      :visible="!!categoryPrintData"
      width="90%"
      @close="closeCategoryPrint()"
    >
      <template v-slot:title>
        <div class="space-between">
          <div>
            <h2>{{ categoryPrintData ? categoryPrintData.category.name : '' }} [{{ getSexString(categoryPrintData.isMale) }}]</h2>
          </div>
          <div>
            <el-button @click="closeCategoryPrint()">{{
              $tc("general.close")
            }}</el-button>
            <el-button
              type="primary"
              @click="
                openPrint(
                  categoryPrintData.category.name,
                  $refs.categoryPrintTable ? $refs.categoryPrintTable.$el : null
                )
              "
              >{{ $tc("general.print") }}</el-button
            >
            </div>
          </div>
      </template>
      <category-print-modal
        v-if="categoryPrintData"
        ref="categoryPrintTable"
        :category="categoryPrintData.category"
        :disciplines="categoryPrintData.disciplines"
        :isMale="categoryPrintData.isMale"
        :isTeam="categoryPrintData.isTeam"
        :competitors="categoryPrintData.isTeam ? teams : competitors"
      />

    </el-dialog>
  </div>
</template>

<script>
import openPrint from '@/common/print'
import { getCompetitors, getCompetitorNames } from './tournament-discipline'
import TournamentPrintModal from '@/components/tournaments/TournamentPrintModal'
import PrintTableDisciplines from '@/components/tournaments/PrintTableDisciplines'
import CategoryPrintModal from '@/components/tournaments/CategoryPrintModal'

export default {
  components: {
    TournamentPrintModal,
    PrintTableDisciplines,
    CategoryPrintModal
  },

  props: {
    tournament: {
      type: Object,
      required: true
    },

    competitors: {
      type: Array,
      required: true
    },

    teams: {
      type: Array,
      required: true
    }
  },

  data () {
    return {
      isMale: null,
      category: null,
      discipline: null,
      isTeam: false,
      modalVisible: false,
      schemaData: null,
      categoryPrintData: null,

      openPrint,
      getCompetitors,
      getCompetitorNames
    }
  },

  computed: {
    modalData () {
      if (!this.category || !this.discipline) return null

      let competitors = this.isTeam ? this.teams : this.competitors
      if (this.isTeam) {
        let filterType = 'WOMEN'
        if (this.isMale === null) filterType = 'MIX'
        if (this.isMale) filterType = 'MEN'
        competitors = competitors.filter(c => c.type === filterType)
      }

      const data =
        getCompetitors(
          this.category.id,
          this.discipline.id,
          competitors
        ) || []

      return this.getParsedData(data)
    },

    data () {
      return [
        {
          label: 'Pregled pojedinačnih disciplina i statistika prijave',
          items: this.getDisciplinesSortedByCategories(
            this.tournament.disciplines || []
          )
        },
        {
          label: 'Pregled ekipnih disciplina i statistika prijave',
          items: this.getDisciplinesSortedByCategories(
            this.tournament.teamDisciplines || []
          ),
          isTeam: true
        }
      ]
    },

    allCategories () {
      return this.$store.state.categories.data
    }
  },

  methods: {
    getSexString (isMale) {
      if (isMale === null) return 'Svi'

      return isMale ? 'Muški' : 'Ženski'
    },
    preGetCompetitors (catId, disciplineId, competitors, filter, isTeam) {
      if (isTeam) {
        let filterType = 'MIX'
        if (filter === 'M') filterType = 'MEN'
        if (filter === 'F') filterType = 'WOMEN'

        competitors = competitors.filter(c => c.type === filterType)
      }

      const data =
        this.getCompetitors(
          catId,
          disciplineId,
          competitors,
          !isTeam && filter
        ) || []

      return data.length || 0
    },

    getParsedData (data) {
      data = JSON.parse(JSON.stringify(data))

      if (!this.isTeam) {
        return data.filter((c) => this.isMale === c.competitor?.isMale)
      }

      // [
      //   'competitor',
      //   'competitorTwo',
      //   'competitorThree',
      //   'competitorFour'
      // ].forEach((key) => {
      //   data.forEach((d) => {
      //     if (this.isMale !== d[key]?.isMale) {
      //       d[key] = null
      //     }
      //   })
      // })

      return data.filter(
        (d) =>
          d.competitor ||
          d.competitorTwo ||
          d.competitorThree ||
          d.competitorFour
      )
    },

    showSex (d, isMale) {
      return !d?.forSex || d.forSex === (isMale ? '1' : '2')
    },

    openPrintSchema (entry) {
      this.schemaData = entry
      this.$nextTick(() => {
        this.openPrint(
          entry.label,
          this.$refs.printSchema ? this.$refs.printSchema.$el : null
        )
      })
    },

    openPreview (cat, disc, isTeam, isMale) {
      this.isMale = isMale
      this.category = cat
      this.discipline = disc
      this.isTeam = isTeam
      this.$nextTick(() => {
        this.modalVisible = true
      })
    },

    closePreview () {
      this.category = null
      this.discipline = null
      this.isTeam = false
      this.modalVisible = false
    },

    getDisciplinesSortedByCategories (disciplines) {
      disciplines = disciplines.map((d) => d.discipline)
      const categoryIdsObject = {}
      disciplines.forEach((d) => {
        d.disciplineCategories.forEach((cat) => {
          categoryIdsObject[cat.categoryId] = true
        })
      })

      const tournamentCategories =
        this.allCategories.filter((category) =>
          Object.keys(categoryIdsObject).includes(category.id + '')
        ) || []

      return tournamentCategories
        .slice()
        .sort((a, b) => {
          const ageDiff = (a.ageFrom ?? 0) - (b.ageFrom ?? 0)
          if (ageDiff !== 0) return ageDiff

          return (a.ageTo ?? 999) - (b.ageTo ?? 999)
        })
        .map((category) => ({
          ...category,
          items: this.getDisciplineFromCategory(disciplines, category.id)
        }))
    },

    getDisciplineFromCategory (disciplines, categoryId) {
      const tournamentDisciplines = disciplines.map((tournamentDiscipline) => ({
        ...tournamentDiscipline,
        categoryIds: tournamentDiscipline.disciplineCategories.map(
          (category) => category.categoryId
        )
      }))

      return tournamentDisciplines.filter((d) =>
        d.categoryIds.includes(categoryId)
      )
    },

    hasMaleDisciplines (category) {
      return category.items.some(d => this.showSex(d, true))
    },

    hasFemaleDisciplines (category) {
      return category.items.some(d => this.showSex(d, false))
    },

    openCategoryPrintSchema (category, entry, isMale) {
      this.categoryPrintData = {
        category,
        disciplines: category.items,
        isMale,
        isTeam: entry.isTeam
      }
    },

    closeCategoryPrint () {
      this.categoryPrintData = null
    }
  }
}
</script>

<style lang="scss" scoped>
label {
  font-weight: bold;
  color: #000;
}

.category-header {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.discipline {
  padding-bottom: 5px;
  span {
    margin-right: 5px;
  }
}
.space-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 30px;
}
</style>
